module.exports = __webpack_public_path__ + "img/vendorcard.45c9318c.svg";